// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + "component---src-pages-home-index-js" + "-" + "ef740c05bb4244c1b556" + ".js";
};